<script lang="ts" setup>
import type { ConnectionProvisionEvent } from "~/models/Connection";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { faSpinnerThird } from "@fortawesome/pro-light-svg-icons";

const status = defineModel<string>("status");
const data = defineModel<ConnectionProvisionEvent["data"]>("data");

const message = computed(() => {
    return status.value === "provisioning_finished" ||
        !data.value?.current_step?.message
        ? data.value?.message
        : data.value?.current_step?.message;
});
const percent = computed(() => {
    if (status.value === "provisioning_finished" || !data.value?.current_step)
        return data.value?.percent;

    return data.value?.current_step?.percent;
});
</script>

<template>
    <UBadge class="gap-2" color="white">
        <FontAwesomeIcon
            v-if="status === 'provisioning_finished'"
            :icon="faCheck"
        />
        <FontAwesomeIcon v-else :icon="faSpinnerThird" spin />
        <div>{{ data?.message }}</div>
        <span>
            <span
                >{{
                    status === "provisioning_finished"
                        ? data?.step
                        : data.step === 0
                          ? 0
                          : data?.step - 1
                }}/{{ data?.max }}</span
            >
            <span v-if="percent > 0 && percent < 100">
                ({{ Math.round(percent) }}%)
            </span>
        </span>
    </UBadge>
</template>
